import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { StockAdjustmentReason } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class StockAdjustmentReasonService extends TmsWebBaseEditService<StockAdjustmentReason, StockAdjustmentReason> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('StockAdjustmentReason', $localize`Stock Adjustment Reason`, httpService, notificationService);
  }
}
